import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { List, Map, fromJS } from 'immutable';
import { PieChart, Pie, LabelList, Cell, Sector } from 'recharts';

import { Icon } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';
import { DetailTemplate, MaterialSnackbar, Loading, LeakCountInfo } from 'components';

import Scrollbar from 'libs/Scrollbar';
import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import styles from './ExamDetail.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamDetailPi extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      detailType,
      selectedDetailData,
      // 훈련 유형
      attachExamType,
      // 감염 PC 로딩
      infectionTarget,
      isLoading,
      isSnackbar
    } = this.props;
    // function
    const { onMoveScroll, onRefRegister, onToggleSnackbar, onToggleDetailView } = this.props;

    // ---------------------------------- 훈련 정보 ----------------------------------
    let detailData = Map({
      examNo: 0,
      examName: '',
      send: 0,
      sendReserve: 0,
      read: 0,
      download: 0,
      cure: 0,
      infection: 0,
      declare: 0,
      edu: 0,
      eduBefore: 0,
      eduPlay: 0,
      eduAfter: 0,
      leakAllcount: 0,
      leakAllsize: 0,
      leakCertCount: 0,
      leakCertSize: 0,
      leakEmailCount: 0,
      leakEmailSize: 0,
      leakFileCount: 0,
      leakFileSize: 0,
      targetNo: 0,
      targetName: '',
      targetEmail: '',
      targetPhone: '',
      targetDivision: '',
      targetPosition: '',
      linkAttach: 0,
      examType: 0,
      attachScreenType: 0
    });

    if (!!selectedDetailData) {
      detailData = selectedDetailData;
    }

    // 피싱 유도 타입의 훈련 양식
    const isPhishing = 4 === detailData.get('examType') ? true : false;

    const btDatas = [
      {
        id: 'move-info',
        iconName: 'list',
        content: defineMessages(formatMessage({ id: 'ExamDetailPi_1', defaultMessage: '대상자 훈련 결과' })),
        isView: true
      },
      {
        id: 'move-infectionFile',
        iconName: 'file text outline',
        content: defineMessages(formatMessage({ id: 'ExamDetailPi_2', defaultMessage: '감염 가능 파일' })),
        isView: isPhishing ? false : true
      },
      {
        id: 'move-pc',
        iconName: 'desktop',
        content: defineMessages(formatMessage({ id: 'ExamDetailPi_3', defaultMessage: '감염 PC' })),
        isView: isPhishing ? false : true
      }
    ];

    // ---------------------------------- 감염 가능 파일 ----------------------------------
    const infectionFileArray = [
      // 데이터가 없을때 표시
      {
        name: '',
        color: '',
        value: detailData.get('leakAllcount') > 0 ? 0 : 100,
        file: '',
        label: '',
        percent: detailData.get('leakAllcount') > 0 ? 0 : 100,
        percentLabel: ''
      },
      {
        name: 'pc',
        color: '#43cbaa',
        value: detailData.get('leakFileCount'),
        file: detailData.get('leakFileSize'),
        label: defineMessages(formatMessage({ id: 'ExamDetailPi_4', defaultMessage: 'PC 파일' })),
        percent: (detailData.get('leakFileCount') / detailData.get('leakAllcount') * 100).toFixed(0),
        percentLabel: (detailData.get('leakFileCount') / detailData.get('leakAllcount') * 100).toFixed(0) + '%'
      },
      {
        name: 'cert',
        color: '#7b3faf',
        value: detailData.get('leakCertCount'),
        file: detailData.get('leakCertSize'),
        label: defineMessages(formatMessage({ id: 'ExamDetailPi_5', defaultMessage: '인증서' })),
        percent: (detailData.get('leakCertCount') / detailData.get('leakAllcount') * 100).toFixed(0),
        percentLabel: (detailData.get('leakCertCount') / detailData.get('leakAllcount') * 100).toFixed(0) + '%'
      },
      {
        name: 'email',
        color: '#6697da',
        value: detailData.get('leakEmailCount'),
        file: detailData.get('leakEmailSize'),
        label: defineMessages(formatMessage({ id: 'ExamDetailPi_6', defaultMessage: '이메일' })),
        percent: (detailData.get('leakEmailCount') / detailData.get('leakAllcount') * 100).toFixed(0),
        percentLabel: (detailData.get('leakEmailCount') / detailData.get('leakAllcount') * 100).toFixed(0) + '%'
      }
    ];

    const InfectionFile = (
      <div className={cx('infectFile-area')}>
        <div className={cx('examInfo')}>
          <span className={cx('allCount')}>
            {defineMessages(formatMessage({ id: 'ExamDetailPi_7', defaultMessage: '총' })) +
              ' ' +
              detailData.get('leakAllcount') +
              defineMessages(formatMessage({ id: 'ExamDetailPi_8', defaultMessage: '개' }))}
          </span>
          <span className={cx('allSize')}>({common.fileSizeTrans(detailData.get('leakAllsize')).common})</span>
        </div>
        <div className={cx('infectFile-item')}>
          <div>
            <PieChart width={130} height={130}>
              <Pie
                dataKey="value"
                data={[
                  {
                    name: 'background',
                    value: 100
                  }
                ]}
                cx={60}
                cy={60}
                paddingAngle={0}
                innerRadius={20}
                outerRadius={55}>
                <Cell fill="#f7f7f7" />
              </Pie>
              <Pie
                dataKey="value"
                data={infectionFileArray}
                cx={60}
                cy={60}
                innerRadius={25}
                outerRadius={50}
                startAngle={450}
                endAngle={90}
                paddingAngle={-1}
                activeIndex={0}
                activeShape={e => {
                  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = e;
                  return (
                    <g>
                      {/* 그라데이션 효과 */}
                      {/* 파일 */}
                      <defs>
                        <linearGradient id="43cbaa" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#39cbd2" />
                          <stop offset="50%" stopColor="#77eadf" />
                          <stop offset="100%" stopColor="#28c3a4" />
                        </linearGradient>
                      </defs>
                      {/* 인증서 */}
                      <defs>
                        <linearGradient id="7b3faf" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#753eaa" />
                          <stop offset="50%" stopColor="#a33ede" />
                          <stop offset="100%" stopColor="#6e19cc" />
                        </linearGradient>
                      </defs>
                      {/* 이메일 */}
                      <defs>
                        <linearGradient id="6697da" x1="0" y1="0" x2="0" y2="1">
                          <stop offset="0%" stopColor="#619dd8" />
                          <stop offset="100%" stopColor="#6649d2" />
                        </linearGradient>
                      </defs>

                      {/* 차트의 기본 형태 영역 */}
                      <Sector
                        cx={cx}
                        cy={cy}
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        fill={fill}
                      />
                      {/* 차트의 확장 처리 */}
                      <Sector
                        cx={cx}
                        cy={cy}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        innerRadius={outerRadius - 1}
                        outerRadius={outerRadius + 8}
                        fill={fill}
                      />
                    </g>
                  );
                }}>
                {/* cell 안에 퍼센트 표시 */}
                {infectionFileArray.map((entry, index) => <Cell key={index} fill={'url(' + entry.color + ')'} />)}
              </Pie>
              <Tooltip
                content={({ payload }) => {
                  return payload.map((entry, index) => {
                    if (entry.name === 'pc' || entry.name === 'cert' || entry.name === 'email') {
                      return (
                        <div className={cx('chart2-tooltip')} key={index}>
                          <div className={cx('name')}>{entry.payload.label}</div>
                          <div className={cx('value')}>
                            {entry.value +
                              defineMessages(formatMessage({ id: 'ExamHeader_2', defaultMessage: '개' })) +
                              ' (' +
                              entry.payload.file +
                              ')'}
                          </div>
                        </div>
                      );
                    }
                  });
                }}
              />
            </PieChart>
          </div>
          <div className={cx('examDetail-infectionFile')}>
            <span className={cx('examDetail-legend')}>
              {infectionFileArray.map(
                (entry, index) =>
                  !!entry.name && (
                    <div className={cx('examInfo')} key={index}>
                      <span className={cx('examInfo-title')}>
                        <Icon name="circle" style={{ color: entry.color }} />
                        {entry.label}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {entry.value}
                        {defineMessages(formatMessage({ id: 'ExamDetail_12', defaultMessage: '개' }))}
                        {' (' + common.fileSizeTrans(entry.file).common + ')'}
                      </span>
                    </div>
                  )
              )}
            </span>
          </div>
        </div>
      </div>
    );

    // ---------------------------------- 감염 PC ----------------------------------
    let InfectionPcComponent = (
      <div className={cx('brand')}>
        <Icon name="checkmark box" />
        {defineMessages(formatMessage({ id: 'ExamDetailPi_9', defaultMessage: '감염 PC 없음' }))}
      </div>
    );
    if (infectionTarget && infectionTarget.get('infectionPc') && infectionTarget.get('infectionPc').size > 0) {
      InfectionPcComponent = infectionTarget.get('infectionPc').map((pc, index) => (
        <Tooltip
          key={index}
          title={
            pc.get('hostname') +
            ' (' +
            pc.get('ip') +
            ') / ' +
            defineMessages(formatMessage({ id: 'TargetDetail_30', defaultMessage: 'PC 감염 시간' })) +
            ': ' +
            common.timeFormatFromUTCEpoch(pc.get('regEpoch'), 1)
          }
          placement="bottom">
          <div className={cx('infectionPc-set')}>
            <div className={cx('pc-info-area ellipsis')}>
              <div className={cx('pc-info', 'ellipsis')}>
                <span className={cx('bold mr-5')}>·</span>
                <span className={cx('pc')}>{pc.get('hostname')}</span>
                <span className={cx('ip')}>{' (' + pc.get('ip') + ')'}</span>
              </div>
              <div className={cx('date-info')}>
                <span>{defineMessages(formatMessage({ id: 'TargetDetail_30', defaultMessage: 'PC 감염 시간' }))}</span>
                <span className={cx('date-text')}>{common.timeFormatFromUTCEpoch(pc.get('regEpoch'), 1)}</span>
              </div>
            </div>
            <div className={cx('count-area')}>
              <LeakCountInfo
                formatMessage={formatMessage}
                type="all"
                count={pc.get('leakAllcount')}
                size={pc.get('leakAllsize')}
              />
              <LeakCountInfo
                formatMessage={formatMessage}
                type="file"
                count={pc.get('leakFileCount')}
                size={pc.get('leakFileSize')}
              />
              <LeakCountInfo
                formatMessage={formatMessage}
                type="cert"
                count={pc.get('leakCertCount')}
                size={pc.get('leakCertCount')}
              />
              <LeakCountInfo
                formatMessage={formatMessage}
                type="mail"
                count={pc.get('leakEmailCount')}
                size={pc.get('leakEmailSize')}
              />
            </div>
          </div>
        </Tooltip>
      ));
    }

    return (
      <DetailTemplate btDatas={btDatas} onMoveScroll={onMoveScroll} onToggleDetailView={onToggleDetailView}>
        <MaterialSnackbar isSnackbar={isSnackbar} onToggleSnackbar={onToggleSnackbar} />
        <Scrollbar
          ref={Scroll => {
            onRefRegister('scroll', Scroll);
          }}>
          <div className={cx('element-wrapper')}>
            {isLoading && (
              <div className={cx('Loading')}>
                <Loading content={'Loading...'} />
              </div>
            )}

            {/* ----------------------------------------- 훈련 정보 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-info')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-info', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_1', defaultMessage: '대상자 훈련 결과' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_10', defaultMessage: '대상자 번호' }))}
                    </span>
                    <span className={cx('examInfo-content')}>{detailData.get('targetNo')}</span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_11', defaultMessage: '대상자 이름' }))}
                    </span>
                    <span className={cx('examInfo-content')}>{detailData.get('targetName')}</span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_12', defaultMessage: '대상자 메일' }))}
                    </span>
                    <span className={cx('examInfo-content')}>{detailData.get('targetEmail')}</span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_13', defaultMessage: '대상자 연락처' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {!!detailData.get('targetPhone') ? detailData.get('targetPhone') : '-'}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_14', defaultMessage: '대상자 소속' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {!!detailData.get('targetDivision') ? detailData.get('targetDivision') : '-'}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_15', defaultMessage: '대상자 직급' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {!!detailData.get('targetPosition') ? detailData.get('targetPosition') : '-'}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_16', defaultMessage: '훈련 번호' }))}
                    </span>
                    <span className={cx('examInfo-content')}>{detailData.get('examNo')}</span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_17', defaultMessage: '훈련명' }))}
                    </span>
                    <span className={cx('examInfo-content')}>{detailData.get('examName')}</span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_18', defaultMessage: '발송' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {detailData.get('send')
                        ? // 발송 일시
                          common.timeFormatFromUTCEpoch(detailData.get('send'))
                        : // 발송 예약(랜덤 발송)
                          detailData.get('sendReserve')
                          ? '(' +
                            defineMessages(formatMessage({ id: 'ExamDetailPi_22', defaultMessage: '발송 예약 일시' })) +
                            ') ' +
                            common.timeFormatFromUTCEpoch(detailData.get('sendReserve'))
                          : '-'}
                    </span>
                  </div>
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {defineMessages(formatMessage({ id: 'ExamDetailPi_19', defaultMessage: '열람' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {common.timeFormatFromUTCEpoch(detailData.get('read'))}
                    </span>
                  </div>
                  {(2 & detailData.get('linkAttach') || isPhishing) && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {isPhishing
                          ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
                          : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {common.timeFormatFromUTCEpoch(detailData.get('download'))}
                      </span>
                    </div>
                  )}
                  <div className={cx('examInfo')}>
                    <span className={cx('examInfo-title')}>
                      {isPhishing
                        ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
                        : defineMessages(formatMessage({ id: 'ExamDetailPi_20', defaultMessage: '감염' }))}
                    </span>
                    <span className={cx('examInfo-content')}>
                      {common.timeFormatFromUTCEpoch(detailData.get('infection'))}
                    </span>
                  </div>
                  {!isPhishing && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'ExamDetailPi_3', defaultMessage: '감염 PC' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {!!infectionTarget && infectionTarget.get('infectionPc')
                          ? infectionTarget.get('infectionPc').size
                          : 0}
                        {defineMessages(formatMessage({ id: 'ExamDetailPi_21', defaultMessage: '대' }))}
                      </span>
                    </div>
                  )}
                  {/* 모의 악성파일 */}
                  {1 === detailData.get('examType') &&
                    2 === attachExamType && (
                      <div className={cx('examInfo')}>
                        <span className={cx('examInfo-title')}>
                          {defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' }))}
                        </span>
                        <span className={cx('examInfo-content')}>
                          {common.timeFormatFromUTCEpoch(detailData.get('cure'))}
                        </span>
                      </div>
                    )}

                  {/* 신고 하기 */}
                  {commonVar.isDeclare === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Declare_3', defaultMessage: '신고' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {common.timeFormatFromUTCEpoch(detailData.get('declare'))}
                      </span>
                    </div>
                  )}
                  {/* 교육 하기 */}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Edu_23', defaultMessage: '교육 개수' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduBefore') +
                          detailData.get('eduPlay') +
                          detailData.get('eduAfter') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetailPi_8', defaultMessage: '개' }))}
                      </span>
                    </div>
                  )}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Edu_24', defaultMessage: '진행전인 교육' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduBefore') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetailPi_8', defaultMessage: '개' }))}
                      </span>
                    </div>
                  )}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Edu_25', defaultMessage: '진행중인 교육' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduPlay') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetailPi_8', defaultMessage: '개' }))}
                      </span>
                    </div>
                  )}
                  {commonVar.isEdu === 1 && (
                    <div className={cx('examInfo')}>
                      <span className={cx('examInfo-title')}>
                        {defineMessages(formatMessage({ id: 'Edu_26', defaultMessage: '학습 완료 교육' }))}
                      </span>
                      <span className={cx('examInfo-content')}>
                        {detailData.get('eduAfter') +
                          ' ' +
                          defineMessages(formatMessage({ id: 'ExamDetailPi_8', defaultMessage: '개' }))}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}
            {/* ----------------------------------------- 감염 가능 파일 ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-infectionFile')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-infectionFile', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_2', defaultMessage: '감염 가능 파일' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>{InfectionFile}</div>
              </div>
            )}
            {/* ----------------------------------------- 감염 PC ----------------------------------------- */}
            {!!btDatas[btDatas.findIndex(btId => btId.id === 'move-pc')].isView && (
              <div
                className={cx('element')}
                ref={ref => {
                  onRefRegister('move-pc', ref);
                }}>
                <div className={cx('segment-title')}>
                  <span className={cx('toggle-title bold')}>
                    {defineMessages(formatMessage({ id: 'ExamDetailPi_3', defaultMessage: '감염 PC' }))}
                  </span>
                </div>
                <div className={cx('segment-content')}>{InfectionPcComponent}</div>
              </div>
            )}
          </div>
        </Scrollbar>
      </DetailTemplate>
    );
  }
}

export default injectIntl(ExamDetailPi);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamDetailPi.js